import { render, staticRenderFns } from "./aftersale.vue?vue&type=template&id=f9eab894&scoped=true"
import script from "./aftersale.vue?vue&type=script&lang=js"
export * from "./aftersale.vue?vue&type=script&lang=js"
import style0 from "./aftersale.vue?vue&type=style&index=0&id=f9eab894&prod&scoped=true&lang=css"
import style1 from "./aftersale.vue?vue&type=style&index=1&id=f9eab894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9eab894",
  null
  
)

export default component.exports